import { Modal } from 'lego-on-react';
import * as React from 'react';
import { ReactNode } from 'react';

import { Bem } from '../../service/Bem/Bem';

import './Message.css';

export interface MessageProps {
    title?: ReactNode;
    children?: ReactNode;
    footer?: ReactNode;
}
const BLOCK = 'message';
export class Message extends React.Component<MessageProps> {
    render() {
        const { title, children, footer } = this.props;
        return (
            <Modal theme="normal" view="classic" visible={true} cls={Bem.cls(BLOCK)}>
                {title && (
                    <div className={Bem.cls(BLOCK, 'header')}>
                        <h3 className={Bem.cls(BLOCK, 'title')}>{title}</h3>
                    </div>
                )}
                {children && <div className={Bem.cls(BLOCK, 'body')}>{children}</div>}
                {footer && <div className={Bem.cls(BLOCK, 'footer')}>{footer}</div>}
            </Modal>
        );
    }
}
